import { Box, TextField, Grid, Typography, Divider, MenuItem } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import { useQuery } from '@tanstack/react-query';
import { sectorService } from '../../../../shared/services/sector/sectorService';
import { useTenant } from '../../../../shared/context/TenantContext';

type UnitFormProps = {
  mode: 'create' | 'edit' | 'view';
  loading?: boolean;
};

export function UnitForm({
  mode,
  loading = false,
}: UnitFormProps) {
    const { selectedTenant } = useTenant();
  const { values, errors, touched, handleChange, setFieldValue } = useFormikContext<any>();
  const isView = mode === 'view';


  const { data: sectors = [] } = useQuery({
    queryKey: ['sectors',selectedTenant],
    queryFn: async () => {
      if (!selectedTenant) return [];
      const res = await sectorService.list({ tenantId:selectedTenant.trim() });
      console.log('Sectors:', res);
      return res.data;
    },
    enabled: !!selectedTenant,
  });

  return (
    <Box sx={{ p: 2, bgcolor: 'background.paper' }}>
      <Typography variant="h6" fontWeight={700} color="primary.main" mb={1} mt={1}>
        Dados da Unidade
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Field
            as={TextField}
            label="Número"
            name="number"
            fullWidth
            required
            disabled={isView || loading}
            error={!!(touched.number && errors.number)}
            helperText={touched.number && errors.number}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            as={TextField}
            select
            label="Setor"
            name="sector_id"
            fullWidth
            required
            disabled={isView || loading}
            error={!!(touched.sector_id && errors.sector_id)}
            helperText={touched.sector_id && errors.sector_id}
            value={values.sector_id}
            onChange={handleChange}
          >
            {sectors.map((sector: any) => (
              <MenuItem key={sector.id} value={sector.id}>
                {sector.name}
              </MenuItem>
            ))}
          </Field>
        </Grid>
        <Grid item xs={12}>
          <Field
            as={TextField}
            label="Descrição"
            name="description"
            fullWidth
            multiline
            minRows={2}
            disabled={isView || loading}
            error={!!(touched.description && errors.description)}
            helperText={touched.description && errors.description}
          />
        </Grid>
      </Grid>
    </Box>
  );
}